import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { usePageContext } from '../../hooks/usePageContext';
import StorageService from '../../services/StorageService';
import { cardSlice } from '../../store/slices';

const CloseCard = () => {
	const dispatch = useDispatch();
	const { useSearchParams, useSelector } = usePageContext();
	const cardId = Number(useSearchParams().get('cardId'));
	useEffect(() => {
		StorageService.UpdateCardList();
	}, []);

	useEffect(() => {
		dispatch(cardSlice.actions.closeCardStart({ cardId }));
	}, [dispatch, cardId]);

	const cardInfo = useSelector(store => store.card?.cardsList?.find(({ Id }) => Id === cardId));
	const closeCard = useSelector(({ card }) => card.closeCard);

	return cardInfo && closeCard ? <Outlet /> : null;
};

export default CloseCard;
